<template>
  <svg width="24px" height="24px"
       viewBox="0 0 24 24" version="1.1"
       xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>atoms/icons/24x24/file/black</title>
    <g id="atoms/icons/24x24/file/black" stroke="none"
       stroke-width="1"
       fill-rule="evenodd">
      <path d="M16.6327933,3 C17.9401655,3 19,4.05731311 19,5.36157494 L19,17.6384251 C19,18.9426869 17.9401655,20 16.6327933,20 L6.36720668,20 C5.05983453,20 4,18.9426869 4,17.6384251 L4,8.77988357 L8.67002231,3 L16.6327933,3 Z M16.6327933,4.57438329 L11.284,4.574 L11.2846754,9.55142169 C11.2846754,10.4209296 10.578119,11.125805 9.70653761,11.125805 L5.578,11.125 L5.57813778,17.6384251 C5.57813778,18.073179 5.93141596,18.4256167 6.36720668,18.4256167 L16.6327933,18.4256167 C17.068584,18.4256167 17.4218622,18.073179 17.4218622,17.6384251 L17.4218622,5.36157494 C17.4218622,4.926821 17.068584,4.57438329 16.6327933,4.57438329 Z M9.706,4.574 L9.42405956,4.57438329 L5.57813778,9.33453118 L5.578,9.551 L9.70653761,9.55142169 L9.706,4.574 Z" id="Combined-Shape"
            fill-rule="nonzero"></path>
    </g>
  </svg>
</template>
<script setup>
// dummy comment to surpress rollup build errors with dynamic imports
// if the file doesn't contain a script tag with content, the build fails.
</script>
